class BFVRadioBtnFormHandler {
  constructor(options = {}) {
    this.$root = options.element;
    this.$radioGroup = this.$root.querySelector('.js-profile-type-radios');
    this.$submitButton = this.$root.querySelector('.js-create-profile-submit');
  }

  init() {
    if (this.$submitButton) {
      this.$submitButton.disabled = !(BFVRadioBtnFormHandler.getRadioGroupValue(this.$radioGroup));
    }

    this.bindEvents();
  }

  bindEvents() {
    if (this.$radioGroup) {
      this.$radioGroup.addEventListener('change', () => {
        this.$submitButton.disabled = !(BFVRadioBtnFormHandler.getRadioGroupValue(this.$radioGroup));
      });
    }
  }

  static getRadioGroupValue($radioGroup) {
    if ($radioGroup && $radioGroup.querySelector(`input[name="${$radioGroup.dataset.radioName}"]:checked`)) {
      return $radioGroup.querySelector(`input[name="${$radioGroup.dataset.radioName}"]:checked`).value;
    }

    return '';
  }
}

export default BFVRadioBtnFormHandler;
